import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    solicitudes: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_SOLICITUDES = 'GET_ALL_SOLICITUDES'
const GET_SOLICITUD_BY_ID = 'GET_SOLICITUD_BY_ID'
const GET_SOLICITUD_BY_ID_INSPECTOR = 'GET_SOLICITUD_BY_ID_INSPECTOR'
const POST_SOLICITUD = 'POST_SOLICITUD'
const UPDATE_SOLICITUD = 'UPDATE_SOLICITUD'
const DELETE_SOLICITUD = 'DELETE_SOLICITUD'
//*******************************************************************************************************************
const GET_SOLICITUDES_AC_UI = 'GET_SOLICITUDES_AC_UI'


//MÉTODOS 
export const getAllSolicitudes = createAsyncThunk(
    GET_ALL_SOLICITUDES,
    async () => {
        try {
            const fullUrl = host + `SolicitudesUIF01/obtenerSolicitudes`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen las Solicituds: '+JSON.stringify(res.data))
            return res
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const getSolicitudById = createAsyncThunk(
    GET_SOLICITUD_BY_ID,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `SolicitudesUIF01/obtenerSolicitudById/${idSolicitud}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getSolicitudByIdInspector = createAsyncThunk(
    GET_SOLICITUD_BY_ID_INSPECTOR,
    async (idInspector) => {
        try {
            const fullUrl = host + `SolicitudesUIF01/obtenerSolicitudByIdInspector/${idInspector}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertSolicitud = createAsyncThunk(
    POST_SOLICITUD,
    async (data) => {
        try {
            const fullUrl = host + `SolicitudesUIF01/agregarSolicitud`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateSolicitud = createAsyncThunk(
    UPDATE_SOLICITUD,
    async (data) => {
        try {
            const fullUrl = host + `SolicitudesUIF01/actualizarSolicitud`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteSolicitud = createAsyncThunk(
    DELETE_SOLICITUD,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `SolicitudesUIF01/eliminarSolicitud/${idSolicitud}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const getAllSolicitudesACUI = createAsyncThunk(
    GET_SOLICITUDES_AC_UI,
    async ({ status, tipo, skip = 0, take = 10 }) => {
        try {
            const fullUrl = `${host}Estatus/obtenerSolicitudesConEstatusYTipo?estatus=${status}&tipo=${tipo}&skip=${skip}&take=${take}`;
            const res = await axios.get(fullUrl);
            return res;
        } catch (error) {
            console.log(error.response);
        }
    }
);
//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosSolicitudesSlice = createSlice({

    name: 'metodosSolicitudesSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllSolicitudes.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.solicitudes = payload.data.data

        },
        [getSolicitudById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.solicitudes = payload.data.data
        },
        [getSolicitudByIdInspector.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.solicitudes = payload.data.data
        },
        [insertSolicitud.fulfilled]: (state, { payload }) => {
            state.solicitudes = payload.data.data
        },

        [updateSolicitud.fulfilled]: (state, { payload }) => {

        },
        [deleteSolicitud.fulfilled]: (state, { payload }) => {

        },

    },

})


export const { } = metodosSolicitudesSlice.actions
export const SolicitudesUIF01Reducer = metodosSolicitudesSlice.reducer